export enum TaskStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  WORK_DONE = 'WORK_DONE',
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  BACKLOG = 'BACKLOG',
  BLOCKED = 'BLOCKED',
}
